import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';
import { useDeepCompareEffect } from 'react-use';

import FlexColumn from '@ui/atoms/FlexColumn';
import LoadingWrapper from '@ui/atoms/LoadingWrapper';
import Skeleton from '@ui/atoms/Skeleton';

import fullWidth from '@ui/styled/FullWidth';

import useMemberInvoiceProposal, { IMemberInvoiceProposal } from '@hooks/useMemberInvoiceProposal';

import { keysToCamel } from '@utils/butter';

import { IPageProps } from '@folx-types/flow-steps';

import MedicationBillsDetailStep, {
	IMedicationBillsDetailStepContent,
} from './MedicationBillsDetailStep.component';

interface IMedicationBillsDetailStepPageProps extends IPageProps {
	path: string;
	billId?: string;
}

const MedicationBillsDetailStepPage: FC<IMedicationBillsDetailStepPageProps> = ({
	path,
	billId,
}) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "mssp-medication-bills-detail-step" }) {
				title
				breadcrumb_label
				paid_bill_label
				paid_bill_disclaimer
				unpaid_bill_shipping
				unpaid_bill_disclaimer
				expired_bill_disclaimer
				bill_not_found_title
				bill_not_found_text
				bill_not_found_button_text
			}
		}
	`);

	const refinedContent: IMedicationBillsDetailStepContent = keysToCamel(
		pageContent
	) as IMedicationBillsDetailStepContent;

	useMemberInvoiceProposal().refetchMemberInvoiceProposals();

	const {
		data: detailMedicationBillsData,
		loading: detailMedicationBillsLoading,
		error: detailMedicationBillsError,
	} = useMemberInvoiceProposal({ invoiceId: billId });

	useDeepCompareEffect(() => {
		if (!detailMedicationBillsError) return;
		console.log(detailMedicationBillsError);
	}, [detailMedicationBillsError]);

	const loading = detailMedicationBillsLoading;

	const FullWidthColumn = fullWidth(FlexColumn);

	const skeleton = (
		<FullWidthColumn gap="md">
			<Skeleton height="sm" fullWidth />
			<Skeleton height="lg" fullWidth />
			<Skeleton height="xxxxxl" fullWidth />
		</FullWidthColumn>
	);

	return (
		<LoadingWrapper loading={loading} skeleton={skeleton}>
			<MedicationBillsDetailStep
				pageContent={refinedContent}
				path={path}
				detailMedicationBill={
					(detailMedicationBillsData && detailMedicationBillsData[0]
						? detailMedicationBillsData[0]
						: null) as IMemberInvoiceProposal
				}
				medicationBillId={billId}
			/>
		</LoadingWrapper>
	);
};

export default MedicationBillsDetailStepPage;
